import { makeRequest } from "../util";
import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export const fetchDeliveryData = (
  destination_id: string,
  chartType: string
) => {
  return makeRequest<Highcharts.SeriesOptionsType[]>(
    "destination_delivery_metrics",
    {
      destination_id,
      chart_type: chartType,
    }
  );
};

const chartOptions: Highcharts.Options = {
  // Use colors from the freshpaint theme, logo, etc and then default colors from the highcharts theme.
  colors: [
    "#60dbbf", // green is always the first color for success rate.
    "#ee5757",
    "#232f3e",
    "#263238",
    "#3f51b5",
    "#7cb5ec",
    "#434348",
    "#90ed7d",
    "#f7a35c",
    "#8085e9",
    "#f15c80",
    "#e4d354",
    "#2b908f",
    "#f45b5b",
    "#91e8e1",
  ],
  navigator: {
    adaptToUpdatedData: true,
  },
  credits: {
    enabled: false,
  },
  title: {
    text: "",
  },
  subtitle: {
    text: "",
  },
  xAxis: {
    type: "datetime",
    title: {
      text: "Date (UTC)",
    },
  },
  yAxis: {
    title: {
      text: "",
    },
    min: 0,
    floor: 0,
  },
  plotOptions: {
    series: {
      animation: false,
      marker: {
        enabled: true,
        radius: 1,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
  },
};

const countChartOptions: Highcharts.Options = {
  yAxis: {
    title: {
      text: "Number of Events",
    },
    min: 0,
    floor: 0,
  },
};

const ratioChartOptions: Highcharts.Options = {
  yAxis: {
    title: {
      text: "Success Rate",
    },
    min: 0,
    floor: 0,
  },
};

export const DeliveryMetricsChart = (destination: any) => {
  let o = countChartOptions;
  if (destination.chartType == "ratio") {
    o = ratioChartOptions;
  }

  const [options, setOptions] = useState({
    ...chartOptions,
    ...o,
    chart: {
      events: {
        load: loadInitialData,
      },
    },
  });

  async function loadInitialData() {
    fetchDeliveryData(destination.destination.id, destination.chartType)
      .then((resp) => {
        setOptions((opt) => ({
          ...opt,
          series: resp.data || [],
        }));
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default DeliveryMetricsChart;
